var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon--wallet",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C8.44774 2.00006 8.00006 2.44774 8 3V3.5V7H6C5.448 7 5 6.551 5 6C5 5.449 5.448 5 6 5V3C4.346 3 3 4.346 3 6V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V9C21 7.897 20.103 7 19 7H18V3C17.9999 2.44774 17.5523 2.00006 17 2H9.5L9 2ZM10.9121 4H15.0879C15.239 4.42592 15.5741 4.761 16 4.91211V7H14C14 6.448 13.552 6 13 6C12.448 6 12 6.448 12 7H10V4.91211C10.4259 4.761 10.761 4.42592 10.9121 4ZM5 8.81641C5.31439 8.92856 5.64761 9 6 9H9H19V19H5L5 8.81641ZM16 13C15.448 13 15 13.448 15 14C15 14.552 15.448 15 16 15C16.552 15 17 14.552 17 14C17 13.448 16.552 13 16 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon--wallet.baf2328c4f8fe793c571b02748bf7bcd.svg";
export { ForwardRef as ReactComponent };